import PropTypes from 'prop-types'
import React, { Component } from 'react'
import CSSModules from 'react-css-modules'

import StandardLandingHeader from 'components/header/landing/standard/standard_landing_header'

import styles from './login_header.scss'

class LoginHeader extends Component {
	render() {

		return (
			<StandardLandingHeader linkHome={this.props.canLinkToHome} />
		)
	}
}

LoginHeader.propTypes = {
	linkType: PropTypes.string,
	canLinkToHome: PropTypes.bool,
}

export default CSSModules(LoginHeader, styles, {allowMultiple: true})
